import { ReactEditor } from 'slate-react';

import { findAboveByType, findBellowByType } from '../../../DolEditor/helpers/node';
import {
  EXERCISE_GAP_FILL_WITH_HINT,
  EXERCISE_GAP_FILL_WITH_HINT_QUESTION_CONTENT,
  EXERCISE_GAP_FILL_WITH_HINT_QUESTION_OPTIONS,
} from '../../plugins/ExerciseGapFillWithHint/types';
import { EXERCISE_GAP_FILL, EXERCISE_GAP_FILL_QUESTION_CONTENT } from '../../plugins/GapFill/types';
import {
  addCorrectAnswer,
  addCorrectAnswerWithExtraOptions,
} from '../CorrectAnswers/transforms/addCorrectAnswer';
import { CORRECT_ANSWER, CORRECT_ANSWERS } from '../CorrectAnswers/types';
import { addExplanation } from '../Explanations/transforms/addExplanation';
import { EXPLANATION, EXPLANATIONS } from '../Explanations/types';
import { BLANK_V2 } from './types';

export const withBlankV2 =
  () =>
  <T extends ReactEditor>(editor: T) => {
    const { normalizeNode } = editor;

    /**
     * Automatically add nodes based on blankV2
     * Example: in ExerciseGapFill, add a new blank = add a new correct answer & add a new expolanation
     * All of those logic will behandled in here
     */
    editor.normalizeNode = (entry) => {
      const [node, path] = entry as [any, any[]];

      if (node?.type === BLANK_V2) {
        switch (node.parentNodeType) {
          case EXERCISE_GAP_FILL_WITH_HINT_QUESTION_CONTENT: {
            const [, gapFillPath] = findAboveByType(editor, path, EXERCISE_GAP_FILL_WITH_HINT);
            const correctAnswer = findBellowByType(editor, gapFillPath, CORRECT_ANSWER, {
              match: (n) => n.forId === node.id,
            });
            const blanks = findBellowByType(editor, gapFillPath, BLANK_V2);
            const currentIndex = blanks.findIndex(([blank]) => blank.id === node.id);

            if (!correctAnswer.length) {
              const [[, correctAnswersPath]] = findBellowByType(
                editor,
                gapFillPath,
                CORRECT_ANSWERS
              );
              // link forId to blank node
              addCorrectAnswerWithExtraOptions(editor, correctAnswersPath.concat(currentIndex), {
                forId: node.id,
                answerType: 'dropdown',
                parentNodeType: EXERCISE_GAP_FILL_WITH_HINT,
                dropdownNodeType: EXERCISE_GAP_FILL_WITH_HINT_QUESTION_OPTIONS,
              });
            }
            return;
          }
          case EXERCISE_GAP_FILL_QUESTION_CONTENT: {
            const [, gapFillPath] = findAboveByType(editor, path, EXERCISE_GAP_FILL);

            const correctAnswer = findBellowByType(editor, gapFillPath, CORRECT_ANSWER, {
              match: (n) => n.forId === node.id,
            });
            const explanation = findBellowByType(editor, gapFillPath, EXPLANATION, {
              match: (n) => n.forId === node.id,
            });

            const blanks = findBellowByType(editor, gapFillPath, BLANK_V2);
            const currentIndex = blanks.findIndex(([blank]) => blank.id === node.id);

            if (!correctAnswer.length) {
              const [[, correctAnswersPath]] = findBellowByType(
                editor,
                gapFillPath,
                CORRECT_ANSWERS
              );
              // link forId to blank node
              addCorrectAnswer(editor, correctAnswersPath.concat(currentIndex), node.id);
            }

            // add explanation if missing
            if (!explanation.length) {
              const [[, explanationsPath]] = findBellowByType(editor, gapFillPath, EXPLANATIONS);
              addExplanation(editor, explanationsPath.concat(currentIndex), node.id);
            }
            return;
          }
        }
      }

      normalizeNode(entry);
    };

    return editor;
  };
